import React from "react";
import {Provider} from "../../__snowpack__/pkg/react-redux.js";
import {ThemeStyles} from "../common/generic-react.styles.js";
import store from "../redux/store.js";
export function withRedux(Component, displayName) {
  const Comp = (props) => /* @__PURE__ */ React.createElement(Provider, {
    store
  }, /* @__PURE__ */ React.createElement(Component, props));
  Comp.displayName = displayName;
  return Comp;
}
export function withStyle(Component, displayName) {
  const Comp = (props) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ThemeStyles, null), /* @__PURE__ */ React.createElement(Component, props));
  Comp.displayName = displayName;
  return Comp;
}
export function withReduxAndStyle(Component, displayName) {
  return withRedux(withStyle(Component, displayName), displayName);
}
